<template>
  <div id="multi-biologicals-listing">
    <div class="projects-links">
      <v-banner class="reminder-banner" v-if="displayBanner" color="info">
        {{ bannerText }}
      </v-banner>
      <BioProjectMaterialsModal
        :group-nid="groupNid"
        :is-in-bio-materials="true"
        data-test="project-link-0"
        v-if="displayLinks"
      />
      <a :href="specifyLink" data-test="project-link-1" v-if="specifyLink"
        >Specify Usage for Projects</a
      >
    </div>
    <div v-for="material in bioMaterialTypes" :key="material">
      <InstitutionalBiologicalsListing
        v-if="!groupNid"
        :material-type="material"
      />
      <GroupContextBiologicalsListing
        v-if="groupNid"
        :material-type="material"
        :group-nid="groupNid"
        :display-id="displayId"
      />
    </div>
  </div>
</template>

<script>
import { usePermissions } from "@/composables/usePermissions";
import { useDrupalSettings } from "@/composables/useDrupalSettings";
import BiologicalsListingStore from "../../store/modules/biologicals_listing";
import GroupContextBiologicalsListing from "./GroupContextBiologicalsListing.vue";
import InstitutionalBiologicalsListing from "./InstitutionalBiologicalsListing.vue";
import BioProjectMaterialsModal from "./BioProjectMaterialsModal.vue";
import VBanner from "../raft/VBanner.vue";

const { config } = useDrupalSettings();

export default {
  name: "MultiBiologicalsListing",
  setup(props) {
    const {
      getPermissions,
      hasPermissions,
      storedPermissions,
      permsInContext,
      resetStoreForTesting,
    } = usePermissions(props.groupNid);
    return {
      getPermissions,
      hasPermissions,
      storedPermissions,
      permsInContext,
      resetStoreForTesting,
    };
  },
  data() {
    return {
      bioMaterialBundles: {},
      displayBanner: false,
      bannerText: `When you are done updating your materials, please review the sections "Associate Biological Materials to Projects", "Specify Usage for Projects", and "Biological Summary," then, certify your registration.`,
      destinationQuery: `node/${this.groupNid}/biologicals/bio-tracking`,
      desiredPermissions: [
        "edit bio_material entities",
        "add bio_material entities",
      ],
    };
  },
  components: {
    InstitutionalBiologicalsListing,
    GroupContextBiologicalsListing,
    VBanner,
    BioProjectMaterialsModal,
  },
  computed: {
    bioMaterialTypes: function () {
      return this.$get("getBioMaterialTypeIds");
    },
    specifyLink() {
      if (this.displayLinks && config.bioTrackingSpecifyUsage) {
        return `/node/${this.groupNid}/biologicals/projects/specify-usage?gids[]=${this.groupNid}&destination=${this.destinationQuery}`;
      }
      return "";
    },
    displayLinks() {
      return (
        (this.permsInContext &&
          this.permsInContext["edit bio_material entities"] &&
          this.permsInContext["add bio_material entities"]) ||
        false
      );
    },
  },
  async created() {
    const store = this.$store;
    this.$store.registerModule(this.namespace, BiologicalsListingStore());
    this.$get = (prop) => store.getters[this.namespace + "/" + prop];
    await store.dispatch(this.namespace + "/fetchBioMaterialBundles");
    await this.getPermissions(this.desiredPermissions);
    await this.$nextTick();
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("searchAdd")) {
      this.displayBanner = true;
    }
  },
  props: {
    groupNid: {
      type: String,
      required: true,
    },
    displayId: { type: String, default: "listing_table" },
    namespace: {
      type: String,
      default: "BiologicalsListingStore",
    },
  },
  methods: {
    errorEmit(message, data) {
      this.$emit("form-error-message", { message: message, data: data });
    },
  },
};
</script>

<style scoped>
.projects-links {
  display: flex;
  flex-direction: column;
}

.reminder-banner {
  margin-bottom: 0.5rem;
}
</style>
